export default function isCurrency(numStr: string) {
  var regex = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;

  return regex.test(numStr);
}
